import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CloseOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { motion, AnimatePresence } from 'framer-motion'
import { Label, Wrapper, Box } from './styled'
import { ModalAssignee } from '../modal-assignee'
import { useProfile, useTaskManagement } from '../../../../hooks'
import { TASK_TYPE_NAME, STATUS_CODE } from '../../constants'

const getStatusClassName = (status) => {
  switch (status) {
    case STATUS_CODE.NOT_STARTED:
      return 'not-started'
    case STATUS_CODE.IN_PROGRESS:
      return 'in-progress'
    case STATUS_CODE.COMPLETED:
      return 'completed'
    default:
      return ''
  }
}

export const Assignee = ({ t, taskCategory, registeredAssignees, setRegisteredAssignees, disabled }) => {
  const { profile: { userId, fullName } } = useProfile()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedAssignees, setSelectedAssignees] = useState([])
  const { sortedUserList, loadTaskUserListAction, loadAssigneeMyselfAction, isCreateTask } = useTaskManagement()
  const { taskTypeName, value } = taskCategory
  const isMyTask = taskTypeName === TASK_TYPE_NAME.MY_TASK

  useEffect(() => {
    if (isMyTask) {
      loadAssigneeMyselfAction({ id: userId, name: fullName })
    } else {
      loadTaskUserListAction({ id: value, taskTypeName })
    }
  }, [taskCategory])

  useEffect(() => {
    if (isCreateTask && isMyTask) {
      // マイタスクのときはログインユーザーを設定する
      const assignee = [{ id: userId, name: fullName }]
      setRegisteredAssignees(assignee)
      setSelectedAssignees(assignee)
    } else if (isCreateTask && !isMyTask) {
      setRegisteredAssignees([])
      setSelectedAssignees([])
    } else {
      setSelectedAssignees(registeredAssignees)
    }
  }, [taskTypeName, userId, fullName, isCreateTask])

  const handleOpen = () => {
    if (disabled) return
    setIsModalVisible(true)
  }

  const handleRemove = (e, id) => {
    e.stopPropagation()
    const removeAssignee = (prev) => prev.filter((assignee) => assignee.id !== id)
    setRegisteredAssignees(removeAssignee)
    setSelectedAssignees(removeAssignee)
  }

  return (
    <>
      <Wrapper>
        <Label>{t('task.assignee')}</Label>
        <Box onClick={handleOpen}>
          <AnimatePresence>
            {registeredAssignees.map(({ id, name, taskStatus }) => (
              <motion.div
                key={id}
                className={`user-item ${getStatusClassName(taskStatus)}`}
                onClick={(e) => e.stopPropagation()}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ duration: 0.2 }}
                role="button"
                tabIndex={0}
              >
                <span>{name}</span>
                {!disabled && (
                <Tooltip title={t('common.delete')}>
                  <button className="remove-item" onClick={(e) => handleRemove(e, id)} disabled={isMyTask ? id === userId : false} type="button">
                    <CloseOutlined />
                  </button>
                </Tooltip>
                )}
              </motion.div>
            ))}
          </AnimatePresence>
        </Box>
      </Wrapper>
      <ModalAssignee
        t={t}
        userList={sortedUserList}
        selectedAssignees={selectedAssignees}
        setSelectedAssignees={setSelectedAssignees}
        registeredAssignees={registeredAssignees}
        setRegisteredAssignees={setRegisteredAssignees}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  )
}

Assignee.propTypes = {
  t: PropTypes.func.isRequired,
  taskCategory: PropTypes.object,
  registeredAssignees: PropTypes.array,
  setRegisteredAssignees: PropTypes.func,
  disabled: PropTypes.bool
}
